import { SITE_URL } from "./config";
import { checkEmailValid } from "./util/general_util";
import { lsModal_view } from "./util/infocards";

declare global {
  interface Window {
    grecaptcha:any;
    recaptchaResponse: string;
    recaptchaInstances:any;
    dataLayer:any[];
  }
}

$(".showLoginForm").on("click", function(event) {
  event.preventDefault();
  let modal:JQuery<HTMLElement> = $(this).closest(".loginSignupWrapper");
  lsModal_view("login",modal);
  Rewardful.Forms.attach();
  $(this).find("[name='affiliateID']").val(Rewardful.affiliate.id);
});
$(".showSignupForm").on("click", function(event) {
  event.preventDefault();
  let modal:JQuery<HTMLElement> = $(this).closest(".loginSignupWrapper");
  lsModal_view("signup",modal);
  Rewardful.Forms.attach();
  $(this).find("[name='affiliateID']").val(Rewardful.affiliate.id);
});

$(".showForgotPassword").on("click", function(event) {
  event.preventDefault();
  let modal:JQuery<HTMLElement> = $(this).closest(".loginSignupWrapper");
  lsModal_view("forgotpassword",modal);
});

$("[forgotpassForm]").on("submit", function(event) {
  event.preventDefault();
  let email:string = ($(this).find("#forgotpassEmailInput").val() as string).trim();
  if (!checkEmailValid(email)) {
    $(this).find("#emailresetErrMsg").html("Email is invalid");
    $(this).find("#emailresetErr").removeClass("d-none");
    return;
  };
  $(this).find("#emailresetErr").addClass("d-none");
  $.ajax({
    type: $(this).attr("method"),
    url: $(this).attr("action"),
    data: $(this).serialize(),
    dataType: "json",
    success: (data, status, xhr) => {
      $(this).find("#forgotpassConfirmation").removeClass('d-none');
      if (data.redirectUrl) {
        window.location.href = data.redirectUrl;
      } else if (data.isRedirect === false) {
        $("body").html(data.html)
      };
    },
    error: (xhr, errMsg, exc) => {
      if (xhr.status == 403) {
        $(this).find("#emailresetErrMsg").html(xhr.responseText);
        $(this).find("#emailresetErr").removeClass("d-none");
      } else if (xhr.status == 429) {
        $(this).find("#emailresetErrMsg").html("Looks like you already have an email to reset your password. Make sure to check your spam and try searching for 'donotreply@adventuregenie.com'");
        $(this).find("#emailresetErr").removeClass("d-none");
      }
    }
  });
});

export async function loginsignup_submit(form:JQuery<HTMLElement>) {
  let success:boolean = false;
  let response:any;
  let errStr:string = "";
  await $.ajax({
    type: form.attr("method"),
    url: form.attr("action"),
    data: form.serialize(),
    dataType: "json",
    tryCount: 0,
    retryLimit: 3,
    success: (data, status, xhr) => {
      success = true;
      response = data;
    },
    error: function (xhr, errMsg, exc) {
      if (errMsg == "timeout") {
        this.tryCount++;
          if (this.tryCount <= this.retryLimit) {
              //try again
              $.ajax(this);
              return;
          }
          return;
      };
      if (xhr.status == 403 || xhr.status == 409 || xhr.status == 410) {
        errStr = xhr.responseText
      } else if (xhr.status == 0) {
        errStr = "Timeout: Please check your internet or firewall settings"
      } else {
        errStr = "Error occured: Please try again or contact support"
      };
    }
  } as JQueryAjaxSettings);

  return new Promise<any>((resolve,reject) => {
    if (success) resolve(response);
    else reject(errStr);
  });
}

// function login_onsubmit(event:JQuery.SubmitEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
//   event.preventDefault();

//   let form:JQuery<HTMLElement> = $(this);
//   let emailInput:JQuery<HTMLElement> = form.find("input[name='email']");
//   let passwordInput:JQuery<HTMLElement> = form.find("input[name='password']");
//   let errEl:JQuery<HTMLElement> = form.find("[errEl]");
//   let submitBtn:JQuery<HTMLElement> = form.find("button[type='submit']");
//   let email:string = (emailInput.val() as string).trim().toLowerCase();
//   if (!checkEmailValid(email)) {
//     errEl.find("[errMsg]").html("Email is invalid");
//     errEl.removeClass("d-none");
//     return;
//   };

//   let redirectUri:string = window.webAuth.baseOptions.redirectUri;
//   redirectUri += "&" + form.serialize();

//   console.log(redirectUri);

//   const password:string = passwordInput.val().toString();

//   do_a0_login(email,password,redirectUri,errEl);
// };

// function do_a0_login(email:string, password:string, redirectUri:string, errEl:JQuery<HTMLElement>) {
//   window.webAuth.login({
//     email: email,
//     password: password,
//     realm: "Username-Password-Authentication",
//     redirectUri: redirectUri,
//   }, function(err:any) {
//     if (err) {
//       console.log(err);
//       errEl.find("[errMsg]").html(err.error_description);
//       errEl.removeClass("d-none");
//     }
//   });
// };

// function signup_onsubmit(event:JQuery.SubmitEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
//   event.preventDefault();

//   let signupForm:JQuery<HTMLElement> = $(this);
//   let emailInput:JQuery<HTMLElement> = signupForm.find("input[name='email']");
//   let passwordInput:JQuery<HTMLElement> = signupForm.find("input[name='password']")
//   let promoCodeInput:JQuery<HTMLElement> = signupForm.find("input[name='signupPromocode']")
//   let errEl:JQuery<HTMLElement> = signupForm.find("[errEl]");
//   let submitBtn:JQuery<HTMLElement> = signupForm.find("button[type='submit']");
//   let email:string = (emailInput.val() as string).trim();
//   if (!checkEmailValid(email)) {
//     errEl.find("[errMsg]").html("Email is invalid");
//     errEl.removeClass("d-none");
//     return;
//   };

//   let redirectUri:string = window.webAuth.baseOptions.redirectUri;
//   redirectUri += "?" + signupForm.serialize();

//   const password:string = passwordInput.val().toString();

//   errEl.addClass("d-none");
//   submitBtn.attr("disabled", "disabled"); // Disable the login button
//   window.webAuth.signup({
//     connection: 'Username-Password-Authentication',
//     email: emailInput.val(),
//     password: password,
//   }, function (err:any) {
//     if (err) {
//       errEl.find("[errMsg]").html(err.description);
//       errEl.removeClass("d-none");
//     } else {
//       try{
//         let signupMessage:string = signupForm.parent().find("[signupmsg]").html()
//         //This is for tracking in Google Ads / Analytics for carded Trial Member Signup, since it doesn't append signup=t to url.
//         window.dataLayer = window.dataLayer || [];
//         window.dataLayer.push({'event': 'memberSignup', 'memberSignupParameters':{'carded':'false', 'message' : signupMessage, 'page':window.location.href}});
//       } catch (error){
//         console.error(error.message)
//       }
//       do_a0_login(email,password,redirectUri,errEl);
//     };
//   });
// };

// $("form[loginForm]").on("submit", login_onsubmit);

// $("form[signupForm]").on("submit",signup_onsubmit);

$("form[loginForm]").on("submit", loginsignup_onsubmit);

export function loginsignup_onsubmit(event:JQuery.SubmitEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
  event.preventDefault();

  let form:JQuery<HTMLElement> = $(this);
  let emailInput:JQuery<HTMLElement> = form.find("input[name='email']")
  let errEl:JQuery<HTMLElement> = form.find("[errEl]");
  let submitBtn:JQuery<HTMLElement> = form.find("button[type='submit']");
  let email:string = (emailInput.val() as string).trim();
  if (!checkEmailValid(email)) {
    errEl.find("[errMsg]").html("Email is invalid");
    errEl.removeClass("d-none");
    return;
  };

  // if (window.recaptchaResponse === undefined || window.recaptchaResponse === null) {
  //   errEl.find("[errMsg]").html("Please complete Captcha");
  //   errEl.removeClass("d-none");
  //   return;
  // };

  let startingCardedTrial:boolean;
  if (form.find("input[name='startCardedTrial'][value='true']").length) {
    startingCardedTrial = true;
  } else {
    startingCardedTrial = false;
  };

  form.find("input[name='grecaptchaResponse']").val(window.recaptchaResponse);

  errEl.addClass("d-none");
  submitBtn.attr("disabled", "disabled"); // Disable the login button

  submitBtn.html("<span class='spinner-border spinner-border-sm' role='status' aria-hidden='true'></span> Loading...");

  loginsignup_submit(form).then(response => {
    window.recaptchaResponse = null;
    window.recaptchaInstances.forEach(function(recaptchaInstance:any) {
      window.grecaptcha.reset(recaptchaInstance);
    });
    submitBtn.removeAttr("disabled"); // Enable the login button
    submitBtn.html("Login");

    try{
      //This is for tracking in Google Ads / Analytics for tracking when a member logs in
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({'event': 'memberLogin'});
    } catch (error){
      console.error(error.message)
    }

    if (response.redirectUrl) {
      window.location.href = response.redirectUrl;
    } else if (response.isRedirect === false) {
      $("body").html(response.html)
    };
  }).catch(e => {
    window.recaptchaResponse = null;
    window.recaptchaInstances.forEach(function(recaptchaInstance:any) {
      window.grecaptcha.reset(recaptchaInstance);
    });
    submitBtn.removeAttr("disabled"); // Enable the login button
    submitBtn.html("Login");
    errEl.find("[errMsg]").html(e.responseText);
    errEl.removeClass("d-none");
  });
};

$("form[signupForm]").on("submit", function(event) {
  event.preventDefault();

  let signupForm:JQuery<HTMLElement> = $(this);
  let emailInput:JQuery<HTMLElement> = signupForm.find("input[name='email']");
  let passwordInput:JQuery<HTMLElement> = signupForm.find("input[name='password']")
  let errEl:JQuery<HTMLElement> = signupForm.find("[errEl]");
  let submitBtn:JQuery<HTMLElement> = signupForm.find("button[type='submit']");
  let email:string = (emailInput.val() as string).trim();
  if (!checkEmailValid(email)) {
    errEl.find("[errMsg]").html("Email is invalid");
    errEl.removeClass("d-none");
    return;
  };

  let startingCardedTrial:boolean;
  if (signupForm.find("input[name='startCardedTrial'][value='true']").length) {
    startingCardedTrial = true;
  } else {
    startingCardedTrial = false;
  };

  errEl.addClass("d-none");
  submitBtn.attr("disabled", "disabled"); // Disable the login button

  submitBtn.html("<span class='spinner-border spinner-border-sm' role='status' aria-hidden='true'></span> Loading...");

  window.webAuth.signup({
    connection: 'Username-Password-Authentication',
    email: emailInput.val(),
    password: passwordInput.val()
  }, function (err:any) {
    if (err) {
        submitBtn.removeAttr("disabled");
        submitBtn.html("Sign Up");
        errEl.find("[errMsg]").html(err.description);
        errEl.removeClass("d-none");
      } else {
        loginsignup_submit(signupForm).then(response => {
          submitBtn.removeAttr("disabled"); // Enable the login button
          submitBtn.html("Sign Up");
          let signupMessage:string = signupForm.parent().find("[signupmsg]").html()
          if (startingCardedTrial) {
            // $(".modal").modal("hide");
            // $("#memberCardedTrialModal").modal("show");
            try{
              //This is for tracking in Google Ads / Analytics for carded Trial Member Signup, since it doesn't append signup=t to url.
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({'event': 'memberSignup', 'memberSignupParameters':{'carded':'true', 'message' : signupMessage, 'page':window.location.href}});
            } catch (error){
              console.error(error.message)
            }
          } else {
            try{
              //This is for tracking in Google Ads / Analytics for carded Trial Member Signup, since it doesn't append signup=t to url.
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({'event': 'memberSignup', 'memberSignupParameters':{'carded':'false', 'message' : signupMessage, 'page':window.location.href}});
            } catch (error){
              console.error(error.message)
            }
          };
          if (response.redirectUrl) {
            window.location.href = response.redirectUrl;
          } else if (response.isRedirect === false) {
            $("body").html(response.html)
          };
        }).catch(e => {
          submitBtn.removeAttr("disabled"); // Enable the login button
          submitBtn.html("Sign Up");
          errEl.find("[errMsg]").html(e.responseText);
          errEl.removeClass("d-none");
        });
      };
  });
});

function evaluatePasswordStrength(passwordStrengthContainer:JQuery<HTMLElement>,password:string) {
  const conditions = {
    lowercase: /[a-z]/.test(password),
    uppercase: /[A-Z]/.test(password),
    number: /\d/.test(password),
    specialChar: /[^a-zA-Z0-9\s\t\n]/.test(password),
  };
  const isLengthValid = password.length >= 8;
  const conditionsMet:number = Object.values(conditions).filter(Boolean).length;
  passwordStrengthContainer.find(".strength-bar-fill").attr("conditionsMet",conditionsMet);

  Object.entries(conditions).forEach(([key,value]) => {
    passwordStrengthContainer.find(`[requirement-${key}]`).find('i').attr('class',value?'ai-circle-check': 'ai-circle-x');
  });
  passwordStrengthContainer.find("[requirement-length]").find('i').attr('class',isLengthValid?'ai-circle-check': 'ai-circle-x');

  return isLengthValid && conditionsMet >= 3;
};

$("form[signupForm] input[name='password']").on("input", function() {
  let form:JQuery<HTMLElement> = $(this).closest("form");
  let submitBtn:JQuery<HTMLElement> = form.find("button[type='submit']");
  let passwordStrengthContainer:JQuery<HTMLElement> = form.find("[passwordStrengthContainer]");

  if ($(this).val().toString().length == 0) {
    passwordStrengthContainer.collapse("hide");
  } else {
    passwordStrengthContainer.collapse("show");
  };
  if (evaluatePasswordStrength(passwordStrengthContainer,$(this).val().toString())) {
    submitBtn.removeAttr('disabled');
  } else {
    submitBtn.attr('disabled','disabled');
  }
});

$(".promoCodeText").on("click", function() {
  let form:JQuery<HTMLElement> = $(this).closest("form");
  let passwordStrengthContainer:JQuery<HTMLElement> = form.find("[passwordStrengthContainer]");
  let promoCodeContent:JQuery<HTMLElement> = form.find("[promoCodeContent]");
  if(passwordStrengthContainer.hasClass("show") && passwordStrengthContainer.hasClass("hide")){
    passwordStrengthContainer.addClass("h-100");
    passwordStrengthContainer.removeClass("show");
    setTimeout(() => {
      passwordStrengthContainer.removeClass("h-100");
      $(this).addClass("d-none");
      promoCodeContent.removeClass("d-none");
    }, 500);
  }else{
    $(this).addClass("d-none");
    promoCodeContent.removeClass("d-none");
  };
});
$("[closePromoContent]").on("click", function() {
  let form:JQuery<HTMLElement> = $(this).closest("form");
  form.find("[promoCodeContent]").addClass("d-none");
  form.find(".promoCodeText").removeClass("d-none");
});